<editor style="height: 100%;" [init]="config" [apiKey]="apiKey" (onBlur)="contentChanged()"
  (ngModelChange)="contentChanged()" [(ngModel)]="content"></editor>
